import { ApiClient } from '@k2/common/backend/api-client';

export class ColaOptionsEndpoint {
  constructor(private api: ApiClient) {
  }

  get = (assignmentServiceInstanceId: number) => {
    return this.api.get(`/assignment-service-instance/${assignmentServiceInstanceId}/cola-options`);
  };

  create = (assignmentServiceInstanceId: number, payload: any) => {
    return this.api.post(`/assignment-service-instance/${assignmentServiceInstanceId}/cola-options`, payload);
  };

  update = (assignmentServiceInstanceId: number, payload: any) => {
    return this.api.patch(`/assignment-service-instance/${assignmentServiceInstanceId}/cola-options`, payload);
  };
}
